module.exports = __webpack_public_path__ + "static/media/phone_active.a6a12218.png";